type PromiseFunction<T> = (data: T) => Promise<T>;
type I_TaskList = PromiseFunction<any>[];

let taskList: I_TaskList = [];

export const queuePromises = (
  firstParam: any,
  tasks: I_TaskList,
  successCallback: (index: number) => void,
  failedCallback: (index: number, err: string) => void
) => {
  taskList = tasks;
  let p = taskList[0];
  let remaining = taskList.slice(1);

  let previousResult = firstParam;
  let index = 0;

  function next() {
    index++;
    p(previousResult)
      .then((result) => {
        // 完成当前Promise, 调用回调
        successCallback(index);

        if (!result) {
          return;
        }

        previousResult = result;

        if (remaining.length) {
          // 还有剩余任务,执行下一个
          p = remaining[0];
          remaining = remaining.slice(1);

          next();
        }
      })
      .catch((err) => {
        // request error
        if (typeof err != 'string') err = JSON.stringify(err);
        if (err && err.request) err = err.response.data.detail;
        if (err && err.message) err = err.message;
        if (!err) err = 'Internal Server Error';
        failedCallback(index, err);
      });
  }

  try {
    next();
  } catch (err) {
    failedCallback(index, JSON.stringify(err));
  }
};
